export default __webpack_public_path__ + "static/media/coat.9fc07172.svg";